import { render, staticRenderFns } from "./chapterlist.vue?vue&type=template&id=49028b3a&scoped=true&"
import script from "./chapterlist.vue?vue&type=script&lang=js&"
export * from "./chapterlist.vue?vue&type=script&lang=js&"
import style0 from "./chapterlist.vue?vue&type=style&index=0&id=49028b3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49028b3a",
  null
  
)

export default component.exports